import { render, staticRenderFns } from "./BulkManagementIframe.vue?vue&type=template&id=82f7c66e&"
import script from "./BulkManagementIframe.vue?vue&type=script&lang=ts&"
export * from "./BulkManagementIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports